import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { BoolToTextPipe } from "../../../../../lib/pipes/bool-to-text.pipe.mjs";

@Component({
  selector: "app-billing-information",
  standalone: true,
  imports: [CommonModule, BoolToTextPipe, ButtonModule, CardModule],
  templateUrl: "./billing-information.component.html",
  styleUrls: ["./billing-information.component.scss"],
})
export class BillingInformationComponent implements OnInit, OnChanges {
  @Input()
  customer_overview = signal<ICustomerOverview | undefined>(undefined);

  hasBillingInformation: boolean = false;

  customerBalance = 0;
  subscriptionTotal = 0;
  latestInvoiceDate = 0;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    console.log(this.customer_overview());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.customer_overview()) {
      this.hasBillingInformation = true;
    } else {
      this.hasBillingInformation = false;
    }

    if (
      this.customer_overview() &&
      this.customer_overview()?.subscriptions &&
      this.customer_overview()?.subscriptions?.data
    ) {
      this.subscriptionTotal =
        this.customer_overview()?.subscriptions?.data.reduce(
          (sum, subscription) => sum + subscription.actual_amount,
          0
        ) ?? 0;
    }

    console.log(this.customer_overview()?.balances);

    if (
      this.customer_overview() &&
      this.customer_overview()?.balances &&
      this.customer_overview()?.balances?.data
    ) {
      this.customerBalance = this.customer_overview()?.balances?.data.reduce(
        (accumulator: any, current: any) =>
          accumulator + current.current_balance,
        0
      );
    }

    if (
      this.customer_overview() &&
      this.customer_overview()?.invoices &&
      this.customer_overview()?.invoices?.data
    ) {
      const create = this.customer_overview()!.invoices!.data.map(
        (a) => a.createdAt
      );

      this.latestInvoiceDate = Math.max(...create);
    }
  }

  makePayment() {

    if (this.activatedRoute.snapshot.params['id'])
    {
      this.router.navigateByUrl("/billing/make-a-payment", this.activatedRoute.snapshot.params['id']);
    }
    else
    {
      this.router.navigateByUrl("/billing/make-a-payment");
    }
  }

  ngOnInit() {}
}
